import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9ac1664"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reject" }
const _hoisted_2 = { class: "reject__content" }
const _hoisted_3 = { class: "text-area" }
const _hoisted_4 = {
  class: "select-area",
  style: {"overflow-y":"scroll"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "请选择快捷批注内容")
], -1))
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "footer" }

import { ref, onMounted } from 'vue';
import {
  BaseDialog,
  BaseButton,
  BaseInput,
  XrkMessage,
  XrkMessageBox
} from 'xrk-components';
import { quickReplyList, deleteQuickReply } from '../data-source/apis';

export default /*#__PURE__*/_defineComponent({
  __name: 'no-pass',
  props: {
    projectId: {},
    remove: {}
  },
  emits: ['confirm'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const textarea = ref('');
const emits = __emit;

const textDefault = [];

const textArray = ref([]);

const removeItem = async id => {
  await XrkMessageBox.confirm('是否删除快捷回复');
  await deleteQuickReply({ id });
  await getList();
};

const confirm = async remarkType => {
  if (!textarea.value) {
    XrkMessage.error('请输入不通过原因');
    return;
  }
  if (textarea.value.length > 200) {
    XrkMessage.error('不通过原因不可超过200字');
    return;
  }
  await XrkMessageBox.confirm('是否确认提交');
  emits('confirm', { remarkType, remarks: textarea.value });
  XrkMessage.success('提交成功');
  props.remove();
};

const getList = async () => {
  const { data } = await quickReplyList({ projectId: props.projectId });
  if (!data) {
    textArray.value = textDefault;
    return;
  }
  textArray.value = [...textDefault, ...data];
};

onMounted(async () => {
  getList();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    title: "审核不通过",
    width: "800px",
    "model-value": true,
    "before-close": props.remove,
    "close-on-press-escape": true
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", null, [
          _createVNode(_unref(BaseButton), {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (confirm(1))),
            type: "primary",
            plain: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 提交并加入快捷回复 ")
            ]),
            _: 1
          }),
          _createVNode(_unref(BaseButton), {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (confirm(0))),
            type: "primary",
            plain: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 仅提交 ")
            ]),
            _: 1
          }),
          _createVNode(_unref(BaseButton), {
            onClick: props.remove,
            type: "default"
          }, {
            default: _withCtx(() => [
              _createTextVNode("关闭")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(BaseInput), {
              style: {"width":"400px"},
              type: "textarea",
              autosize: {
              minRows: 9
            },
              maxlength: 200,
              "show-word-limit": true,
              placeholder: "请输入批注(您可以点击下方内容进行快捷回复)",
              modelValue: textarea.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((textarea).value = $event)),
              modelModifiers: { trim: true }
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("ol", null, [
              _hoisted_5,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(textArray.value, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "select-text",
                  key: index,
                  onClick: ($event: any) => (textarea.value += item.content)
                }, [
                  _createElementVNode("span", null, _toDisplayString(index + 1) + "." + _toDisplayString(item.content), 1),
                  (item.id)
                    ? (_openBlock(), _createBlock(_unref(BaseButton), {
                        key: 0,
                        size: "small",
                        type: "text",
                        plain: "",
                        onClick: _withModifiers(($event: any) => (removeItem(item.id)), ["stop"]),
                        style: {"color":"red","width":"50px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" ✖ ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_6))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["before-close"]))
}
}

})